import React, { useEffect, useState, useMemo } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link, useParams, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import {
  CardBody,
  Container,
  Row,
  Card,
  Alert,
  Spinner,
  Col,
} from "reactstrap";

// Import Breadcrumb
import BreadCrumb from "../../../../Components/Common/BreadCrumb";

import TableContainer from "../../../../Components/Common/TableContainer";
// Import actions
import { getOrganisateurs as onGetOrganisateurs } from "../../../../store/actions";

import Loader from "../../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../../axiosConfig";

// Redux
import { useSelector, useDispatch } from "react-redux";
import InfosPersonnelle from "../../../../Components/Common/InfosPersonnelle";
import StatistiquesDetail from "../../../../Components/Common/StatistiquesDetail";

const OrganizerActivityHistory = (props) => {
  const { id: agentId } = useParams();

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
  };

  const { organisateurs } = useSelector((state) => ({
    organisateurs: state.Organisateur.organisateurs,
  }));

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [selectOrga, setSelectOrga] = useState({});
  const [selectEventOrga, setSelectEventOrga] = useState([]);

  useEffect(() => {
    dispatch(onGetOrganisateurs());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(organisateurs)) {
      const orgaDetail = organisateurs.data.find(
        (organisateur) => organisateur.id == agentId
      );
      if (orgaDetail) {
        setSelectOrga(orgaDetail);
      }
    }
  }, [organisateurs, agentId]);

  const fetchEventOrgaData = async () => {
    try {
      const EventOrgaDetail = await axiosInstance.get(
        `/eventgetallfororga/?organisation_id=${agentId}/`
      );

      setSelectEventOrga(EventOrgaDetail.data.data);
    } catch (err) {
      console.error("Échec de récupération des données: ", err);
      toast.error("Échec de récupération des données.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEventOrgaData();
  }, [agentId]);

  const columnsTable = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: "last_name",
        filterable: false,
        Cell: (cell) => cell.row.original.last_name,
      },
      {
        Header: "Prénom",
        accessor: "first_name",
        filterable: false,
        Cell: (cellProps) => cellProps.row.original.first_name,
      },
      {
        Header: "Date",
        accessor: "date",
        filterable: false,
        Cell: (cellProps) => formatDate(cellProps.row.original.date),
      },
      {
        Header: "Rôle",
        accessor: "role",
        filterable: true,
      },
    ],
    []
  );

  const columnsInfo = [
    {
      Header: "Nom",
      accessor: "last_name",
    },
    {
      Header: "Prénoms",
      accessor: "first_name",
    },
    {
      Header: "Téléphone",
      accessor: "telephone",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Pays",
      accessor: "pays",
    },
  ];

  const columnStatistique = [
    {
      title: "Evenements",
      prefix: "",
      suffix: "",
      value: selectEventOrga.length || 0,
    },
  ];

  document.title = props.t("Détails de l'organisateur | Takci");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Détails de l'organisateur"
            pageTitle="Organisateurs"
            pageTitleLink="/organisateurs"
          />
          {loading ? (
            <div className="text-center my-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <Row g={2}>
              <Col className="col-xxl-3 align-items-center">
                <Card className="h-100 w-100">
                  {selectOrga.first_name && selectOrga.last_name ? (
                    <InfosPersonnelle
                      avatar={
                        <div className="avatar-title bg-light text-dark rounded">
                          <i
                            className={`ri ri-car-fill`}
                            style={{ fontSize: "50px" }}
                          />
                        </div>
                      }
                      status={selectOrga.etat}
                      head={selectOrga.first_name + " " + selectOrga.last_name}
                      columns={columnsInfo}
                      data={selectOrga}
                    />
                  ) : (
                    <Alert color="warning">
                      Aucune information disponible.
                    </Alert>
                  )}
                </Card>
              </Col>

              <Col className="col-xxl-9 align-items-center">
                <Card className="h-100 w-100">
                  <StatistiquesDetail data={columnStatistique} />
                  {selectEventOrga.length > 0 ? (
                    <Card>
                      <CardBody>
                        <div className="table-card gridjs-border-none pb-2">
                          <TableContainer
                            columns={columnsTable}
                            data={selectEventOrga || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            divClass="table-responsive"
                            tableClass="mb-0 table-borderless"
                            theadClass="table-light text-muted"
                          />
                        </div>
                      </CardBody>
                    </Card>
                  ) : (
                    <Alert color="warning">Aucun Evénement disponible.</Alert>
                  )}
                </Card>
              </Col>
            </Row>
          )}

          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

OrganizerActivityHistory.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(OrganizerActivityHistory));
